import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";

class ScrollTo extends Component {
    constructor(props) {
        super();
        this.state = {
            isActive: false,
        };
        this.observer = null;
        this.header = null;
    }
    componentDidMount() {
        this.header = document.querySelector("#header");

        //Setup intersection observer
        if (!this.observer && this.header) {
            this.observer = new IntersectionObserver(
                (entries, observerItem) => {
                    for (const entry of entries) {
                        if (entry.intersectionRatio <= 0) {
                            if (!this.state.isActive) {
                                this.setState({
                                    isActive: true,
                                });
                            }
                        } else {
                            this.setState({
                                isActive: false,
                            });
                        }
                    }
                },
                { threshold: [0, 0.25, 0.5, 0.75, 1] }
            );

            this.observer.observe(this.header);
        }
    }
    componentWillUnmount() {
        if (this.observer) {
            this.observer.unobserve(this.header);
        }
    }
    scrollToPos = () => {
        window.scrollTo({
            top: this.props.position || 0,
            behavior: "smooth",
        });
    };

    render() {
        const cssClass = this.state.isActive ? "-active" : "";

        return (
            <div className={`to-top ${cssClass}`} onClick={this.scrollToPos}>
                <FontAwesomeIcon icon={faArrowUp} />
            </div>
        );
    }
}

export default ScrollTo;
